export function BooleanToUint8(value: boolean): Uint8Array {
  return new Uint8Array([value ? 1 : 0])
}
